import React from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import dayjs from 'dayjs';
import { CalendarExport } from './CalendarExport';
import { CalendarDay } from './types';

interface CalendarHeaderProps {
  currentDate: dayjs.Dayjs;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  days: CalendarDay[];
  caseName: string;
  isMobile?: boolean;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  onPrevMonth,
  onNextMonth,
  days,
  caseName,
  isMobile,
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'stretch', sm: 'center' },
      gap: { xs: 2, sm: 0 },
      mb: 3,
    }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6">
          {currentDate.format('MMMM YYYY')}
        </Typography>
      </Box>
      <Box sx={{ 
        display: 'flex', 
        gap: 2, 
        alignItems: 'center',
        justifyContent: { xs: 'space-between', sm: 'flex-end' },
      }}>
        <CalendarExport 
          days={days} 
          caseName={caseName}
          isMobile={isMobile}
        />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton 
            onClick={onPrevMonth}
            sx={{ 
              width: { xs: 40, sm: 36 },
              height: { xs: 40, sm: 36 },
            }}
          >
            <ChevronLeft />
          </IconButton>
          <IconButton 
            onClick={onNextMonth}
            sx={{ 
              width: { xs: 40, sm: 36 },
              height: { xs: 40, sm: 36 },
            }}
          >
            <ChevronRight />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};